import { apiConstructor as api } from '@/api/apiConstructor';
import { Content, ContentList, PartialContent } from '@/types/content';
import { ContentHistory } from '@/types/history';
import { AxiosRequestConfig, AxiosResponse } from 'axios';

export async function checkUrlExists(url: string): Promise<boolean> {
  const config: AxiosRequestConfig = {
    params: { url },
  };

  const response: AxiosResponse = await api.get('content/checkurl', config);
  return response.data.exists;
}

export async function getContent(
  id: string,
  commit?: string,
): Promise<Content> {
  const config: AxiosRequestConfig = {
    params: { commit },
  };

  try {
    const response: AxiosResponse = await api.get(`content/${id}`, config);
    return response.data;
  } catch (error) {
    return error.data;
  }
}

export async function getContentPage(
  page: number,
  category: string,
  showDeleted?: boolean,
  terms?: string,
): Promise<ContentList> {
  const config: AxiosRequestConfig = {
    params: {
      page,
      category,
      show_deleted: showDeleted,
      search: terms,
    },
  };

  try {
    const response: AxiosResponse = await api.get('content', config);
    return response.data;
  } catch (error) {
    return error.data;
  }
}

export async function deleteContent(
  id: string,
  redirect?: string,
): Promise<void> {
  const data = { redirect };
  api.delete(`content/${id}`, { data });
}

export async function restoreContent(id: string): Promise<void> {
  api.put(`content/${id}/restore`);
}

export async function publishContent(
  id: string,
  commitHash: string | null,
): Promise<Content> {
  const data = { commitHash };
  const response: AxiosResponse = await api.put(`content/${id}/publish`, data);
  return response.data;
}

export async function unpublishContent(
  id: string,
  redirect?: string,
): Promise<Content> {
  const data = { redirect };
  const response: AxiosResponse = await api.put(
    `content/${id}/unpublish`,
    data,
  );
  return response.data;
}

export async function getHistory(id: string): Promise<ContentHistory[]> {
  const response: AxiosResponse = await api.get(`content/${id}/history`);
  return response.data;
}

export async function saveContent(
  content: Content | PartialContent,
): Promise<Content> {
  const url: string =
    content.id === undefined ? 'content' : `content/${content.id}`;

  const response: AxiosResponse =
    content.id === undefined
      ? await api.post(url, { ...content })
      : await api.put(url, { ...content });
  return response.data;
}
